<template>
  <div class="u-wrap">
    <van-tabs v-model="active" color="#3e78f7">
      <van-tab title="问题墙">
        <wtq></wtq>
      </van-tab>
      <van-tab title="回音壁">
        <hyb></hyb>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import wtq from '@/views/hmhq/problem-wtq.vue'
import hyb from '@/views/hmhq/problem-hyb.vue'
export default {
  components: {
    wtq,hyb
  },
  data() {
    return {
      active:0
    }
  },
  created() {
     
  },
  mounted() {
    
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/less/dialog.less';
.u-wrap {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #f5f5f5;
  padding-bottom: 60px;
  padding-top: 12px;
}
</style>
